/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FileSizeDistributionItem,
    FileSizeDistributionItemFromJSON,
    FileSizeDistributionItemFromJSONTyped,
    FileSizeDistributionItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface FileSizeDistribution
 */
export interface FileSizeDistribution {
    /**
     * 
     * @type {Array<FileSizeDistributionItem>}
     * @memberof FileSizeDistribution
     */
    distribution: Array<FileSizeDistributionItem>;
}

export function FileSizeDistributionFromJSON(json: any): FileSizeDistribution {
    return FileSizeDistributionFromJSONTyped(json, false);
}

export function FileSizeDistributionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileSizeDistribution {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'distribution': ((json['distribution'] as Array<any>).map(FileSizeDistributionItemFromJSON)),
    };
}

export function FileSizeDistributionToJSON(value?: FileSizeDistribution | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'distribution': ((value.distribution as Array<any>).map(FileSizeDistributionItemToJSON)),
    };
}


